import { MediaMobile, MediaSmallMobile } from "api/const/MediaQuery"
import clsx from "clsx"
import XmarkIcon from "components/atoms/iconsComponent/XmarkIcon"
import { MessageComponent } from "components/organism"
import { LoginType } from "components/types/Context"
import useMediaQuery from "hook/useMediaQuery"
import { useContext, useEffect, useRef, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { addZero, fromGetMonthToMonthName } from "shared/utils/formatFunction"
import pinkIcon from '../../../assets/logo192.png'

export const ChatMessageMobilePage = () => {
  const { matchList,
    loginType,
    reqMessagesList,
    matchSelected,
    reqMatchList,
    setReqMessagesList,
    messagesList,
    setMatchSelected,
    getMatchList,
    getMessagesList
  } = useContext(AppGeneralContext)

  const [logoStatup] = useState<string>(matchSelected?.startup.logoUrl ? matchSelected?.startup.logoUrl : pinkIcon)
  const chatEndRef = useRef<any>(null)
  const route = loginType === LoginType.startup ? 'start-up' : "corporate"
  const navigate = useNavigate()
  const mobile = useMediaQuery(MediaMobile)
  const xs = useMediaQuery(MediaSmallMobile)

  useEffect(()=>{
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" })
  },[messagesList])

  const clickHandler = () => {
    setMatchSelected(undefined)
    navigate(`/${route}/profile/messaging`)
  };

  useEffect(() => {
    if (reqMessagesList.matchId !== "") {
      getMessagesList()
    }
  }, [reqMessagesList.matchId])

  return (

    <div className="full-h  chat-mobile-header ">
      <div className={clsx(" d-flex  justify-content-between chat-title-mobile ")}>
        <div className={clsx("d-flex  h-100   ",
          { "flex-row align-items-center justify-content-start": !mobile },
          { "flex-column justify-content-center align-items-start": mobile })}>
         <Link to={`/${route}/profile/messaging`} className=" link d-flex w-100 search-info justify-content-between align-items-center">
                    <h4 className="">{"< Messaging "}</h4>
          </Link>
          <div className={clsx("d-flex   ps-2 align-items-center",
            { "pt-2": mobile }
          )}>
            <img className="w-15 " src={loginType === LoginType.corporate ? logoStatup : pinkIcon} alt="logo startup" />
            <h4 className="m-0 p-0 ms-2 fw-900 uppercase">{loginType === LoginType.corporate ? matchSelected?.startup.name : matchSelected?.company.name}</h4>
          </div>
        </div>
        <div
          onClick={() => clickHandler()}
          className={clsx("d-flex  justify-content-end ps-3 pe-3   ",
            { " align-items-center": !mobile },
            { " align-items-start pt-2": mobile })}
        >
          <XmarkIcon className="xIcon " />
        </div>
      </div>
      <div className=" chat-box-mobile d-flex  justify-content-center  h-100  ">
        <div className={clsx("chat-content-mobile  pt-3   no-overflow h-100",
          { "w-45 ps-4 pe-4": !mobile && !xs },
          { "w-75 ps-2 pe-2": mobile && !xs },
          { "w-100 ": mobile && xs })}>
          {messagesList.map((x) => {

            const messageDate = new Date(x.dateAction)
            const dayMessage = addZero(messageDate.getDate())
            const monthMessage = fromGetMonthToMonthName(messageDate.getMonth())
            const yearMessage = messageDate.getFullYear()
            const dateMessage = dayMessage + " " + monthMessage + " " + yearMessage


            return <div key={x.id} className="">
              {x.showDate &&
                <div className="d-flex flex-row w-100 pt-2 pb-2 align-items-center">
                  <div className="date-message-line " />
                  <p className="date-message ps-3 pe-3 p-0 m-0"> {dateMessage} </p>
                  <div className="date-message-line " />
                </div>
              }
              <MessageComponent
                message={x}
                startup={matchSelected?.startup}
                corporate={matchSelected?.company}
              />
            </div>
          })
          }
          <div style={{height:"25vh"}} ref={chatEndRef} />
        </div>
      </div>
    </div>
  )
}